import dayjs, { type Dayjs } from 'dayjs'
import { type SourceDatabase } from '../../utils/note'

/**
 * Single source of truth for timeframe configuration
 * Maps timeframe prefixes to active types
 */
export const TIMEFRAME_CONFIG = {
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
  quarterly: 'quarter',
  yearly: 'year',
} as const

// Derive types automatically from the config
export type TimeframePrefix = keyof typeof TIMEFRAME_CONFIG
export type ActivePeriod = (typeof TIMEFRAME_CONFIG)[TimeframePrefix]

// Create reverse mapping automatically
export const ACTIVE_PERIOD_TO_PREFIX = Object.fromEntries(
  Object.entries(TIMEFRAME_CONFIG).map(([prefix, active]) => [active, prefix])
) as Record<ActivePeriod, TimeframePrefix>

export type SelectedDate = {
  activePeriod: ActivePeriod
  date: Dayjs
  week: number
  year: number
  teamspace?: string // uuid of teamspace note
  source?: SourceDatabase
}

export type SelectedDateAction =
  | { type: 'today'; forceDay?: boolean; teamspace?: string }
  | { type: 'add' | 'subtract'; amount: number; unit: dayjs.ManipulateType }
  | { type: 'shift'; direction: number }
  | { type: 'transform'; to: ActivePeriod; teamspace?: string }
  | { type: 'setWeek'; week: number; year: number; teamspace?: string }
  | { type: 'setDay'; date: Dayjs; teamspace?: string }
  | { type: 'setMonth'; month: number; year: number; teamspace?: string }
  | { type: 'setQuarter'; quarter: number; year: number; teamspace?: string }
  | { type: 'setYear'; year: number; teamspace?: string }
